import { z } from "zod";

import { createCustomSettings } from "@rootreeweb/zod-to-elements";

/** The different types of emails that can be received. */
export const newslettersEN = z
	.union([
		z.literal("Newsletters"),
		z.literal("Product Updates"),
		z.literal("Surveys"),
		z.literal("Marketing"),
		z.literal("The Pouch Collective Notifications"),
		z.string(),
	])
	.describe(
		createCustomSettings({
			isCheckBoxList: true,
			label: "What kind of emails would you like to receive from us?",
		}),
	);

/** The different types of emails that can be received. */
export const newslettersFR = z
	.union([
		z.literal("Infolettres"),
		z.literal("Des nouvelles de nos produits"),
		z.literal("Sondages"),
		z.literal("Marketing"),
		z.literal("Les notifications du Pouch Collective"),
		z.string(),
	])
	.describe(
		createCustomSettings({
			isCheckBoxList: true,
			label: "Quel type de courriels aimeriez-vous recevoir de notre part ?",
		}),
	);

/** The text that the user must agree with to receive emails. */
export const consentTextEN = z.boolean().describe(
	createCustomSettings({
		label: `I consent to receiving email notifications from Rootree (which can be contacted at hello@rootree.ca). You can unsubscribe at any time.`,
	}),
);

/** The text that the user must agree with to receive emails. */
export const consentTextFR = z.boolean().describe(
	createCustomSettings({
		label: `Je consens à recevoir des avis par courriel de la part de Rootree (que vous pouvez contacter à l'adresse hello@rootree.ca). Vous pouvez vous désabonner en tout temps.`,
	}),
);

/** The time at which the user agreed to receive emails. */
export const consentTime = z
	.date()
	.default(() => new Date())
	.describe(createCustomSettings({ hide: true }));
